import tinycolor2 from 'tinycolor2';
/* c0lors from initial iteration */
var clrs = [
    { hex: '#E14436', hsl: [5, 74, 55], rgb: [225, 68, 54] },
    { hex: '#EDD500', hsl: [54, 100, 46], rgb: [237, 213, 0] },
    { hex: '#00AD23', hsl: [132, 100, 34], rgb: [0, 173, 35] }, // green
];
var DEFAULT_COLORS = [clrs[0].hsl, clrs[1].hsl, clrs[2].hsl];
/**
 * @param percentage - number between 0 and 100
 * @param colors{optional} - array of 3 colors in hsl format
 * @returns object with hsl, rgb and hex values
 */
export function getColorInRange(percentage, colors) {
    if (colors === void 0) { colors = DEFAULT_COLORS; }
    var color1 = colors[0], color2 = colors[1], color3 = colors[2];
    var resultColor = [];
    var colorMin = color2;
    var colorMax = color3;
    var percentageRatio = 50;
    if (percentage <= 50) {
        colorMin = color1;
        colorMax = color2;
        percentageRatio = 0;
    }
    for (var i = 0; i < 3; i++) {
        resultColor.push(colorMin[i] + (colorMax[i] - colorMin[i]) * ((percentage - percentageRatio) / 50));
    }
    var h = resultColor[0], s = resultColor[1], l = resultColor[2];
    var tinyColorInstance = tinycolor2({ h: h, s: s, l: l });
    return {
        hsl: tinyColorInstance.toHslString(),
        rgb: tinyColorInstance.toRgbString(),
        hex: tinyColorInstance.toHexString(),
        raw: {
            rgb: tinyColorInstance.toRgb(),
            hsl: tinyColorInstance.toHsl(),
            hex: tinyColorInstance.toHex()
        }
    };
}
